<template>
  <div id="app">
    <nav-bar />
    <transition name="fade-down" mode="out-in">
      <keep-alive>
        <router-view />
      </keep-alive>
    </transition>
  </div>
</template>

<script>
import NavBar from "./components/NavBar.vue";

export default {
  components: {
    "nav-bar": NavBar
  }
};
</script>

<style lang="scss">
@import url("https://fonts.googleapis.com/css2?family=Open+Sans:ital,wght@0,300;0,400;0,600;0,700;0,800;1,300;1,400;1,600;1,700;1,800&display=swap");
@import url("https://fonts.googleapis.com/css?family=Vollkorn");
@import url("https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap");
@import url("https://fonts.googleapis.com/css2?family=PT+Mono&display=swap");
@import "assets/_media_sizes.scss";
@import "assets/_colours.scss";
@import "assets/_font.scss";

* {
  box-sizing: border-box;
}

body {
  margin: 0;
}

#app {
  font-family: "Open Sans", sans-serif;
  display: flex;
  width: 100%;
  max-width: 100%;
  background-color: $bg-grey;

  p,
  li {
    line-height: 1.5;
  }

  .fade-down-enter-active {
    animation-name: fadeInDown;
    animation-duration: 0.5s;
  }

  .fade-down-leave-active {
    animation-name: fadeOutDown;
    animation-duration: 0.4s;
  }

  .pink-tag {
    display: inline-block;
    color: $accent-pink;
    background: $accent-light-pink;
    font-family: "PT Mono", monospace;
    font-size: $font-XXS;
    padding: 2px 10px;
    margin: 0 10px 5px 0;
  }

  .mini-icon {
    margin-right: 10px;
    color: $accent-blue;
  }

  @keyframes fadeInDown {
    from {
      opacity: 0.05;
      transform: translate3d(0, -25px, 0);
    }
    to {
      opacity: 1;
      transform: none;
    }
  }

  @keyframes fadeOutDown {
    from {
      opacity: 1;
      transform: none;
    }
    to {
      opacity: 0.05;
      transform: translate3d(0, -25px, 0);
    }
  }

  .main {
    display: block;
    flex-grow: 1;
    min-height: 100vh;
    z-index: 1;
    max-width: 1400px;
    margin: 0 auto;

    .page-title {
      font-family: $accent-font;
      color: $dark-grey;
      font-weight: bold;
      font-size: 45px;
      margin-top: 0;

      @media only screen and (max-width: $tablet-potrait) {
        font-size: 30px;
      }
    }

    .hide {
      display: none;
    }
  }
}

@media only screen and (min-width: $phone-S) {
  #app {
    .main {
      padding: 70px 20px 20px 20px;

      .page-title {
        margin-bottom: 10px;
      }
    }
  }
}

@media only screen and (min-width: $phone-L) {
  #app {
    .main {
      padding: 70px 75px;
    }
  }
  //to fill
}

@media only screen and (min-width: $tablet-potrait) {
  #app {
    .main {
      .page-title {
        margin-bottom: 20px;
      }
    }
  }
}

@media only screen and (min-width: $tablet-landscape) {
}

@media only screen and (min-width: $desktop) {
}

@media only screen and (min-width: $desktop-lg) {
}

@media only screen and (min-width: $desktop-xlg) {
}
</style>
